module.exports = __webpack_public_path__ + "img/微课01.dbd1a4e4.svg";